import React, { useState } from "react";
import styles from "./SubscribeButton.module.scss";

const SubscribeButton = ({ isSubscribed, user, userPerms, toggleSubscriptionModalFun, toggleUnsubscribeModal }) => {
  const [buttonText, setButtonText] = useState("Subscribed \u2713");

  const handleMouseOver = () => {
    setButtonText("Unsubscribe");
  };

  const handleMouseOut = () => {
    setButtonText("Subscribed \u2713");
  };

  return (
    <>
      {userPerms["subscriber"] === true && user?.access ? (
        <button
          className={styles.subscribedButton}
          onClick={toggleUnsubscribeModal}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
        >
          {buttonText}
        </button>
      ) : (
        <button
          className={styles.subscribeButton}
          onClick={toggleSubscriptionModalFun}
        >
          Subscribe
        </button>
      )}
    </>
  );
};

export default SubscribeButton;
